import { useTranslation } from "react-i18next"
import { images } from "../../constants"

const posts = [
  {
    id: 1,
    title: 'Privacy in Education',
    href: '/articles/privacy',
    description:
      'The importance of data privacy in education, and the essential strategies.',
    imageUrl: images.classroom,
    date: 'Dec 18, 2023',
    category: 'Education',
  },
  {
    id: 2,
    title: 'Seating Arrangements and Learning',
    href: '/articles/seatingarrangement',
    description:
      'The relationship between classroom seating arrangement and maximized academic and social development of students.',
    imageUrl: images.student,
    date: 'Jun 10, 2023',
    category: 'Education',
  },
]

export default function Blog() {
  const { t } = useTranslation()
  return (
    <section id="research" className="mx-auto max-w-[1152px] px-6 py-24 sm:py-28 lg:px-16">
      <div className="flex flex-col gap-12">
        <div className="flex flex-col items-center gap-3.5 text-center">
          <h2 className="text-4xl font-bold tracking-[-1px] text-ink">{t("blogTitle")}</h2>
          <p className="text-base text-muted">{t("blogText")}</p>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {posts.map((post) => (
            <a
              key={post.id}
              href={post.href}
              className="flex flex-col gap-4 rounded-4xl bg-surface p-4 pb-6 shadow-card transition-all duration-200 hover:-translate-y-1 hover:shadow-elevated"
            >
              <img
                alt=""
                src={post.imageUrl}
                className="h-60 w-full rounded-2xl object-cover"
              />
              <div className="flex flex-col gap-2 px-3">
                <div className="flex items-center gap-2.5 text-xs font-medium text-muted">
                  {post.date}
                  <span className="rounded-full bg-tint px-2.5 py-[3px] text-[11px] font-semibold text-[#8C5A2E]">
                    {post.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-ink">{post.title}</h3>
                <p className="text-sm leading-relaxed text-muted">{post.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
